import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { IconService } from '../../icon.service';
import { IconButtonComponent } from '../../icon-button/icon-button.component';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-data-pad-card-header',
    imports: [IconButtonComponent, TooltipModule],
    templateUrl: './data-pad-card-header.component.html',
    styleUrls: ['./data-pad-card-header.component.scss'],

})
export class DataPadCardHeaderComponent implements OnInit {

  @Input() text = "";
  @Input() showEdit = true;
  @Input() showDataPad = true;
  @Input() showClose = false;

  @Output() dataPadClick = new EventEmitter<void>()
  @Output() editClick = new EventEmitter<void>()
  @Output() closeClick = new EventEmitter<void>()

  subscriptions: Subscription[] = []
  allowDataPadButton = true

  constructor(
    public icons: IconService,
    private breakpointService: BreakpointService,
  ) {}
 
  ngOnInit(): void {
    this.subscriptions.push(this.breakpointService.dataPadFullScreen.subscribe(
      state => {
        this.allowDataPadButton = !state.matches
      }
    ))
  }


  dataPadClicked() {
    this.dataPadClick.emit()
  }

  editClicked() {
    this.editClick.emit()
  }

  closeClicked() {
    this.closeClick.emit()
  }
}
